import { SingleValue } from "react-select";

export type CustomSelectProps = {
    name: string,
    value: string,
    defaultValue?: Option,
    options: Option[],
    handleChange: (newValue: SingleValue<Option>) => void,
    placeholder?: string,
    hasError?: boolean,
    isDisabled?: boolean,
};

export type Option = {
    value: string,
    label: string,
}

export const option = (value: string, label: string): Option => ({ value, label })
